import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";
import { ConstructionCostPoint, fetchConstructionCosts } from "src/site/estat";
import { ChartSpec, debounce, isSp, renderChart } from "src/site/recharts";

// Site::PrefectureArea::ConstructionCost::Component の Stimulus コントローラ。
// landIeul: components/PrefectureApartment/ConstructionCost/index.tsx の LineChart。

class SitePrefectureAreaConstructionCostController extends Controller<HTMLElement> {
  static targets = ["graph", "descriptionUp", "descriptionDown"];
  static values = { areaCode: String };

  declare readonly graphTarget: HTMLElement;
  declare readonly descriptionUpTarget: HTMLElement;
  declare readonly descriptionDownTarget: HTMLElement;
  declare readonly areaCodeValue: string;

  private graphData: ConstructionCostPoint[] = [];
  private onResize?: () => void;

  connect(): void {
    this.onResize = debounce(() => this.draw());
    window.addEventListener("resize", this.onResize);
    void this.load();
  }

  disconnect(): void {
    if (this.onResize) window.removeEventListener("resize", this.onResize);
  }

  private async load(): Promise<void> {
    const result = await fetchConstructionCosts(this.areaCodeValue);
    if (!result) return;
    this.graphData = result.graphData;
    this.descriptionUpTarget.hidden = !result.isUp;
    this.descriptionDownTarget.hidden = result.isUp;
    this.draw();
  }

  private draw(): void {
    if (this.graphData.length === 0) return;
    renderChart(this.graphTarget, this.spec());
  }

  private spec(): ChartSpec {
    const sp = isSp();
    const tickFontSize = sp ? "10px" : "12px";
    const strokeWidth = sp ? 2 : 3;
    return {
      kind: "line",
      data: this.graphData as unknown as ChartSpec["data"],
      xKey: "year",
      xPadding: { left: 20, right: 20 },
      xTickFontSize: tickFontSize,
      yTickFontSize: tickFontSize,
      yUnit: "万円",
      yLocaleString: true,
      curve: "monotone",
      legendWrapperStyle: {
        "font-size": sp ? "10px" : "15px",
        "margin-left": "20px",
        "line-height": "40px",
      },
      series: [
        { key: "woodenConstructionCost", name: "木造", stroke: "#FF367F", fill: "#FF367F", strokeWidth, unit: "万円" },
        { key: "steelReinforcedConstructionCost", name: "鉄骨鉄筋コンクリート", stroke: "#66CDAA", fill: "#66CDAA", strokeWidth, unit: "万円" },
        { key: "reinforcedConcreteConstructionCost", name: "鉄筋コンクリート", stroke: "#2C7CFF", fill: "#2C7CFF", strokeWidth, unit: "万円" },
        { key: "steelConstructionCost", name: "鉄骨", stroke: "#FFE477", fill: "#FFE477", strokeWidth, unit: "万円" },
      ],
      containerStyle: "width:100%;height:100%;min-width:0",
    };
  }
}

application.register(
  "site--prefecture-area--construction-cost",
  SitePrefectureAreaConstructionCostController,
);
